// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"br_jd","breadcrumbs__items":"br_jf","breadcrumbs__item":"br_jg"};